export default {
  plural: 'Twin-ассети',
  upload: 'Завантажити ассет',
  createTitle: 'Завантажити ассет',
  editTitle: 'Редагувати ассет',
  deleteTitle: 'Видалити ассет',
  deleteWarning: 'Ви впевнені, що хочете видалити цей ассет?',
  deleteInUse:
    'Ассет не можна видалити: він використовується деталями. Спочатку відв’яжіть його від деталей.',
  columns: {
    name: 'Назва',
    assetType: 'Тип',
    company: 'Компанія',
    mimeType: 'MIME-тип',
    createdAt: 'Створений'
  },
  profile: {
    title: 'Profile',
    parsedAt: 'Розпізнано',
    parsedNotSaved: 'Розібрано локально, ще не збережено',
    isFrameOnly: 'Frame only',
    warnings: 'Попередження',
    mountCorrection: 'Орієнтація кріплення',
    mountCorrectionHint:
      'Застосовується до конекторів перед збереженням. Ніжкам зазвичай потрібен поворот 180° навколо Z, ручкам +90° навколо X.',
    applyMountCorrection: 'Застосувати орієнтацію',
    sockets: 'Sockets',
    connectors: 'Connectors',
    zones: 'Zones',
    materials: 'Materials',
    reparse: 'Перепарсити',
    parse: 'Розпізнати',
    noProfileYet: 'Профіль ще не створено'
  },
  overrides: {
    open: 'Перевизначення',
    title: 'Перевизначення профілю',
    meshesTitle: 'Меші',
    meshZoneColumn: 'Зона',
    noZone: '—',
    customZone: 'Своя зона…',
    customZoneHint:
      'Створіть zone template з цим кодом, щоб він з’явився у списку',
    nodesTitle: 'Вузли',
    markColumn: 'Мітка',
    group: 'Група',
    position: 'Позиція',
    kind: 'Вид',
    save: 'Зберегти',
    reuploadNote:
      'Перевизначення зберігаються на асеті та перезастосовуються при Reparse і перезаливці GLB; посилання на перейменовані меші/вузли перетворюються на попередження профілю.',
    loadError: 'Не вдалося завантажити GLB для редагування'
  }
};
